module.exports = __webpack_public_path__ + "static/media/image2.dcd2b280.JPG";